
document.addEventListener('DOMContentLoaded', function () {
    //    轮播默认点击最后一个
    const body = $('body')
    setTimeout(() => {
        // pages/sale 
        if (body.hasClass('sale')) {
            $('.custom-style-slide-sale .pf-slider-nav button:last-child').click()
        }
        if (body.hasClass('real-reviews')) {
            $('.pagination-style-2 button:last-child').click()
        }
        if (body.hasClass('refer-earn')) {
            $('.pagination-style-2 button:last-child').click()
        }

    }, 1000);


})

